import styled from 'styled-components';
import { imageFitCover } from '_utils/styles';

export const ImageContainer = styled.div`
  position: relative;
  padding-top: 42.86%; /* 21:9 Aspect Ratio (divide 9 by 21 = 0.4285714286) */
  width: 100%;
`;

export const Link = styled.a`
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  position: absolute;
  outline: 0 !important;

  body:not(.safe-focus-removal) &:focus {
    &:before {
      content: '';
      position: absolute;
      left: -5px;
      top: -5px;
      z-index: 1;
      width: calc(100% + 10px);
      height: calc(100% + 10px);
      outline: 0;
      border-color: ${({ theme }) => theme.colors.element.focused};
      border-width: 2px;
      border-style: solid;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
    }
  }
`;

export const Image = styled.img`
  ${imageFitCover}
`;
